module.exports = __webpack_public_path__ + "img/202105211151047230my.cbca3476.png";